import { useAppStore } from "@/hooks/useAppStore";
import { DisplayMessage } from "@/types";
import { DDiv } from "../ui/ddiv";

export function MessagePopup() {
    const preferredLanguage = useAppStore((state) => state.preferredLanguage);
    const messages = useAppStore((state) => state.messages);
    const focusedMessageId = useAppStore((state) => state.focusedMessageId);
    const message: DisplayMessage | undefined = messages.find(
        (msg) => msg.timestamp === focusedMessageId
    ) as DisplayMessage | undefined;
    const setMessagePopupOpen = useAppStore((state) => state.setMessagePopupOpen);

    return (
        <>
            <button
                onClick={() => setMessagePopupOpen(false)}
                className="absolute top-6 right-6 z-10 w-8 h-8 rounded-full hover:bg-gray-300 flex items-center justify-center shadow transition border-2 border-white cursor-pointer"
                aria-label="Exit message focusing"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M6 6L18 18M6 18L18 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </button>
            <DDiv
                className="relative flex h-full items-center justify-center chat-container p-4"
                onDoubleClick={() => setMessagePopupOpen(false)}
            >
                <div
                    className="relative flex h-full w-full p-10 rounded-xl bg-background shadow-lg"
                >
                    <div className="relative flex items-center justify-center h-full overflow-auto w-full rounded-xl py-4">
                        {message && (
                            <span
                                className="font-bold text-center break-words"
                                style={{
                                    wordBreak: "break-word",
                                    width: "100%",
                                    maxHeight: "100%",
                                    display: "block",
                                    fontSize: "clamp(2rem, 4vmax, 6rem)",
                                    lineHeight: 1.1,
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {message.translations[preferredLanguage as any] ||
                                    message.message}
                            </span>
                        )}
                    </div>
                </div>
            </DDiv>
        </>
    );
}
